import React from "react";
import { string, bool, func } from "prop-types";
import * as i18nUtils from "util/i18n";

import I18n from "pages/_components/I18n";
import Drawer from "pages/_components/Drawer/Drawer";
import CustomData from "pages/_components/CustomData/CustomData";
import InfoDropdown from "./InfoDropdown";

const EnvironmentHelpSlide = ({ page, slideIsVisible, closeSlide, paywayTerminalType, isDesktop }) => {
    const pagesHelpData = {
        StepGeneralData: [
            {
                title: "Mi empresa es residente fiscal en el exterior",
                description:
                    "La Ley sobre el Cumplimiento Fiscal relativa a Cuentas en el Extranjero (FATCA) es un régimen amplio y puede impactar a cualquier persona natural o jurídica, estadounidense o extranjera, en la medida que esa persona esté involucrada en la realización o recepción de pagos que encuadren dentro del ámbito de Ciudadano, Residente legal, Residente tributario, empresa, sucesión o fideicomiso de los EE.UU.",
            },
            {
                title: "Fecha de inscripción registral",
                description:
                    "Es la fecha en la que realizaste la inscripción de tu empresa ante el organismo de control. En caso de que no recuerdes la fecha la pódes encontrar en el inicio del estatuto como Fecha de inscripcion de tu empresa, o puedes buscarla ingresando a https://www.argentina.gob.ar/justicia/registro-nacional-sociedades",
            },
            {
                title: "Ente regulador",
                description:
                    "Es el organismo estatal donde desarrollaste al inscripción de tu empresa, estas se encargan de controlar que funcionen correctamente los servicios públicos a cargo de empresas Privadas. En Argentina (IGJ,Registro Público de comercio,CNV,ETC).",
            },
            {
                title: "Sujeto Obligado",
                description:
                    "Los Sujetos Obligados son las personas humanas y jurídicas determinadas en el artículo 20 de la Ley N°​ 25.246 y modificatorias. Cada uno de ellos está regulado por una resolución específica que rige su actividad. Para conocer si eres Sujeto Obligado consulta en https://sro.uif.gob.ar/SROAPP/#/consultaRegistracion",
            },
            {
                title: "Domicilio fiscal",
                description:
                    "Es el lugar donde se localiza al obligado tributario, ya sea persona física o jurídica, en sus relaciones con la Administración, se debe consignar no sólo al momento de su inscripción sino que deben incorporarlo además en sus declaraciones juradas, formularios o en los escritos que presenten ante la Administración local.",
            },
            {
                title: "Domicilio legal",
                description:
                    "Sede donde la empresa desarrolla su actividad principal y administrativa,señalado expresamente en el estatuto o contratos sociales.",
            },
        ],
        StepTaxData: [
            {
                title: "Certificado MyPyME",
                description:
                    "Es un documento que acredita la condición de PyME y su categorización ante la ARCA, el Ministerio de Desarrollo Productivo y otros organismos e instituciones, a través de la inscripción en el Registro MiPyMES.",
            },
        ],
        StepBeneficiaries: [
            {
                title: "Beneficiarios finales",
                description:
                    "Los Beneficiarios finales son las personas humanas que tienen como mínimo la tenencia -directa o indirecta- del 10% del capital social  y/o derechos de voto de la empresa.",
            },
        ],
        StepLegalRepresentative: [
            {
                title: "Representante legal",
                description:
                    "El representante legal es quien actúa en nombre de otra persona y que es reconocido por la ley. Puede ser uno o varios socios o, si lo prefieren, puede ser un tercero. En cualquier caso, esta figura es la encargada de representar la toma de decisiones de la empresa.",
            },
        ],
        StepShareholders: [
            {
                title: "Socios/accionistas",
                description:
                    "Un Socio/accionista es una persona natural o jurídica que es titular de acciones emitidas por una sociedad anónima en particular. Debido a ello, se convierte en uno de los propietarios o dueños de la sociedad.",
            },
        ],
        StepProxies: [
            {
                title: "Apoderados",
                description:
                    "Un apoderado es una figura legal que representa a una empresa o entidad en asuntos legales y administrativos. Esta figura es muy común en el ámbito empresarial, ya que permite que una empresa pueda actuar de manera más eficiente y ágil en ciertos trámites y gestiones.",
            },
        ],
        StepDocumentation: [
            {
                title: "Estatuto o contrato social",
                description:
                    "Los estatutos son las normas por las que se regirá el funcionamiento de la entidad. En ellos se contemplan temas de vital importancia, como la forma de adoptar acuerdos, la forma de administrar la sociedad (un solo administrador o varios, solidarios o mancomunados, o un consejo de administración); el nombramiento de la persona o personas que van a desempeñar ese papel.",
            },
            {
                title: "Actas de designacion y distribucion de las autoridades",
                description:
                    "En las actas de pueden constar la aceptación de los cargos y los datos completos de las autoridades (nombre, apellido, estado civil, DNI o LC, nacionalidad, CUIT o CUIL, domicilio y profesión) y el cargo en que se ha designado a cada uno y la mayoría por la cual se los designó.",
            },
            {
                title: "Ventas desde la fecha de constitución",
                description:
                    "La certificación contable de ventas es un informe realizado por un Contador Público matriculado, quien certifica la constatación de los hechos y circunstancias vertidos por el contribuyente en su manifestación concuerdan con la documentación respaldatoria y registros contables y extracontables examinados.",
            },
            {
                title: "Últimas 3 (tres) posiciones mensuales de IVA",
                description:
                    "Son las declaraciónes juradas que se presenta en ARCA mensualmente a través del FORMULARIO 2002.",
            },
            {
                title: "Balance",
                description:
                    "Es un estado financiero donde se muestra la situación económica y financiera de una empresa en un momento determinado. En él se encuentran reflejados, como si de una fotografía se tratara, todos los bienes, derechos y obligaciones de una empresa. con el fin de poder analizar la situación de esta y sus problemas financieros.",
            },
            {
                title: "Acta del órgano de gobierno que aprueben el último balance",
                description:
                    "La aprobación de balances, estados de resultados, memoria, informe del síndico -de corresponder- y notas complementarias la debe efectuar la asamblea de accionistas o reunión de socios en el caso de una sociedad de responsabilidad limitada, y constituye el requisito previo a su presentación. La ley general de sociedades en su artículo 234 nos dice que a la asamblea ordinaria le corresponde el tratamiento del balance general, estado de resultados, distribución de ganancias, memoria e informe del síndico -en caso de corresponder- y aclara que la misma debe ser convocada para tratar ese punto dentro de los 4 meses de cerrado el ejercicio.",
            },
            {
                title: "Ventas post cierre de balance",
                description:
                    "Es una lista completa de las cuentas del balance que tienen un saldo cero al final del período del informe en el que se encuentra. Estas cuentas son temporales que la empresa ya ha cerrado; los saldos de estas cuentas ya han pasado a la cuenta de ganancias retenidas durante el cierre de la cuenta. Por ello, no verá ningún detalle de ingresos o pérdidas, ni un balance contable resumido en el balance de comprobación posterior al cierre. En su lugar, cualquiera de esas partidas que aparezca después de que haya finalizado el proceso de cierre y se haya calculado el balance de comprobación posterior al cierre se trasladará al siguiente periodo contable.",
            },
        ],
        StepRegulatoryDataOnboarding: [
            { title: "FATCA", description: "Lorem ipsum...." },
            { title: "CRS / OCDE", description: "Lorem ipsum...." },
            { title: "PEP", description: "Personas expuestas politicamente." },
        ],
    };

    const titleClassname = isDesktop ? "title-content" : "text-center title-content";

    if (
        page === "StepAcceptPayway" ||
        (page === "StepSelectPaywayTerminalType" && paywayTerminalType === null) ||
        page === "StepSelectPaywayCategory" ||
        page === "StepPaywayTerminals"
    ) {
        const items = Array.from([1, 2, 3, 4]);

        const items2 = Array.from([1, 2, 3]);
        return (
            <Drawer className="help-slider" openSidebar={slideIsVisible} toggleSidebar={closeSlide}>
                <div className="container">
                    <h1 className={titleClassname}>
                        {i18nUtils.get("onboarding.stepPayway.title.drawer", "¿Por qué agregar una terminal?")}
                    </h1>
                    <div>
                        <ul>
                            {items.map((value) => (
                                <li className="payway-list-li">
                                    <I18n
                                        style={{ marginLeft: "6px" }}
                                        id={`onboarding.stepPayway.first.help.text.${value}`}
                                        component="span"
                                    />
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <p>
                            <CustomData titleText="onboarding.stepPayway.first.help.title.2" titleTextType="I18N" />
                        </p>
                        <>
                            <ul>
                                {items2.map((value) => (
                                    <li className="payway-list-li">
                                        <span>
                                            {i18nUtils.get(`onboarding.stepPayway.first.help.secondPart.text.${value}`)}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </>
                    </div>

                    <br />
                    <br />
                </div>
            </Drawer>
        );
    }

    if (page === "StepSelectPaywayTerminalType") {
        return (
            <Drawer className="help-slider" openSidebar={slideIsVisible} toggleSidebar={closeSlide}>
                <div className="container payway-terminal-type-help-container">
                    <h1 className={titleClassname}>
                        {i18nUtils.get(`payway.select.terminal.help.${paywayTerminalType}.title`)}
                    </h1>
                    <div>
                        <h3 className="text-justify">
                            {i18nUtils.get(`payway.select.terminal.help.${paywayTerminalType}.description`)}
                        </h3>
                    </div>

                    <br />
                    <br />
                </div>
            </Drawer>
        );
    }

    return (
        <Drawer className="help-slider" openSidebar={slideIsVisible} toggleSidebar={closeSlide}>
            <div className="container">
                <h1 className="text-center title-content">Ayuda</h1>
                <div className="row">
                    {pagesHelpData?.[page]?.map((definition) => (
                        <InfoDropdown title={definition.title} description={definition.description} />
                    ))}
                </div>
            </div>
        </Drawer>
    );
};

EnvironmentHelpSlide.propTypes = {
    isDesktop: bool,
    page: string.isRequired,
    slideIsVisible: bool.isRequired,
    closeSlide: func.isRequired,
    paywayTerminalType: string,
};

EnvironmentHelpSlide.defaultProps = {
    paywayTerminalType: null,
    isDesktop: false,
};

export default EnvironmentHelpSlide;
